export default {
    digitalCardTitle: 'Digitalt kort',
    digitalCardIngress: 'Her vises en representasjon av ditt kort',
    digitalCardHideCoundownText: 'Kortinformasjon vil skjules automatisk om {} sekunder',
    digitalCardFetchError: 'Vi beklager, det digitale kortet kunne ikke vises akkurat nå.',
    digitalCardInvalidCardError: 'Vi beklager, vi klarer ikke å hente en digital versjon av dette kortet.',
    digitalCardNetsCommunicationError: 'Vi beklager, vi får ikke hentet digitalt kort fra leverandør akkurat nå.',
    digitalCardLeadText:
        'Kortdetaljene dine er synlig 1 minutt av gangen. Nedtellingen begynner med en gang, men det kan ta litt tid før bildet kommer.',
    digitalCardButtonText: 'Se digitalt kort',
    digitalCardErrorTitle: 'Digitalt kort er ikke tilgjengelig akkurat nå',
    digitalCardErrorDescription: 'Kontakt banken for mer informasjon.',

    digitalCardLowAssuranceText:
        'Vi er nødt til å forsikre oss om at ingen forsøker å utgi seg for å være deg. Gjennom en enkel bildeverifisering får du tilgang til å se det digitale kortet ditt igjen.',

    digitalCardOnlyNativeWarning:
        'Denne funksjonen krever ekstra sikkerhet og er derfor nå kun tilgjengelig i mobilbanken. For å se digitale kortet ditt må du altså bruke Appen',
};
